import BottomModal from "components/common/Modal/BottomModal";
import Button from "components/common/buttons/buttons";
import Input from "components/common/inputs";
import Select from "components/common/select";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TYPO } from "styles/Typo";
import useModalClickOutside from "utils/useModalClickOutside";
import SelectModal from "./SelectOptionModal";
import Image from "next/image";
import { useRouter } from "next/router";

function AlarmNewMailModal({
  setModalOpen,
  isModalOpen,
  newMail,
  setNewMail,
}: any) {
  const { t } = useTranslation("detail");
  const router = useRouter();
  const mailDomain = [
    t("inputDirectly"),
    "naver.com",
    "gmail.com",
    "daum.net",
    "nate.com",
    "yahoo.com",
    "hanmail.net",
    "outlook.com",
    "icloud.com",
  ];

  const [email, setEmail] = useState("");
  const [emailComplete, setEmailComplete] = useState("");

  const [error, setError] = useState(false);

  const [domain, setDomain] = useState(""); // 직접입력 도메인
  const [mailIndex, setMailIndex] = useState(-1);
  const [mailModal, setMailModal] = useState(false);

  useEffect(() => {
    if (email) {
      const emailComplete = `${email}${
        mailIndex !== -1
          ? mailIndex === 0
            ? domain
              ? "@" + domain
              : ""
            : "@" + mailDomain[mailIndex]
          : ""
      }`;
      setEmailComplete(emailComplete);
    }
  }, [email, domain, mailIndex]);

  const modalRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    event.stopPropagation();

    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      if (mailModal) return;
      setModalOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  useEffect(() => {
    setError(false);
  }, [email, domain, mailIndex]);

  const inputRef = useRef<HTMLInputElement>(null);
  const [focused, setForcused] = useState(false);
  const clearInput = () => {
    setMailIndex(-1);
  };

  const handleBlur = () => {
    // 블러 이벤트 처리를 지연시켜 버튼 클릭 이벤트가 먼저 처리될 수 있도록 함
    setTimeout(() => {
      setForcused(false);
    }, 100); // 100ms 지연
  };

  return (
    <>
      <BottomModal
        isOpen={isModalOpen}
        modalRef={modalRef}
        containerClass="!gap-[30px]"
      >
        <h1 className={`${TYPO.TYPO4_B} text-gray80`}>
          {t("enterNewAddress")}
        </h1>
        <div className="w-full  justify-start gap-2 flex flex-col">
          <div className="flex h-[52px] gap-1 w-full justify-start items-center ">
            <div className="flex-1 cursor-pointer">
              <Input
                placeholder={t("email")}
                type="box"
                size="lg"
                value={email}
                setValue={setEmail}
                width="w-full"
              />
            </div>
            <p className={`${TYPO.TYPO5_MD}`}>@</p>
            <div
              className="flex-1"
              onClick={() => {
                if (mailIndex !== 0) {
                  setMailModal(true);
                }
              }}
            >
              {mailIndex !== 0 ? (
                <Select
                  state={mailIndex === -1 ? "init" : "active"}
                  select={
                    mailIndex === -1 ? t("select") : mailDomain[mailIndex]
                  }
                  size="lg"
                  type="box"
                  width="w-full"
                />
              ) : (
                //   <Input
                //     placeholder={t("directInput")}
                //     type="box"
                //     size="lg"
                //     value={domain}
                //     setValue={setDomain}
                //     width="w-full"
                //   />
                <div
                  className={`w-full flex-col justify-start  gap-1.5 inline-flex`}
                >
                  <div className={`flex relative w-full`}>
                    <input
                      type={"text"}
                      value={domain}
                      onFocus={() => setForcused(true)}
                      onBlur={handleBlur}
                      onChange={(e) => setDomain(e.target.value)}
                      ref={inputRef}
                      placeholder={t("directInput")}
                      className={`box-input w-full h-[54px] px-3 py-2 bg-gray2 ${TYPO.TYPO5_MD} pl-3 text-gray90 border border-gray5 rounded-xl `}
                    />

                    {focused && domain && domain.length > 0 && (
                      <div
                        className="w-[30px] h-[30px] flex justify-center items-center z-30 x-btn absolute top-[50%] translate-y-[-50%] cursor-pointer right-[10px]"
                        onClick={clearInput}
                      >
                        <Image
                          alt="x"
                          src={"/images/icons/x.svg"}
                          height={20}
                          width={20}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {error && (
            <span className={`${TYPO.TYPO7_MD} text-red40 pl-1`}>
              {router.locale === "ko"
                ? "이메일 형식이 올바르지 않습니다."
                : "Invalid email format."}
            </span>
          )}
        </div>

        <Button
          type={"primary"}
          size={"lg"}
          text={t("confirm")}
          width="w-full"
          clickHandler={() => {
            if (
              emailComplete === "" ||
              mailIndex === -1 ||
              (mailIndex === 0 && domain === "") ||
              (mailIndex === 0 && !domain.includes(".")) ||
              !emailComplete.includes("@") ||
              emailComplete.length > 30 ||
              emailComplete.length < 5
            ) {
              setError(true);
              return;
            }
            setNewMail(emailComplete);
            setModalOpen(false);
          }}
          disabled={
            email === "" ||
            mailIndex === -1 ||
            (mailIndex === 0 && domain === "")
            // ||(mailIndex === 0 && !domain.includes("."))
          }
        />
      </BottomModal>
      {mailModal && (
        <SelectModal
          isModalOpen={mailModal}
          data={mailDomain}
          title={t("select")}
          selectIndex={setMailIndex}
          setModal={setMailModal}
          index={mailIndex}
        />
      )}
    </>
  );
}
export default AlarmNewMailModal;
